// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AgentDemoController from "./agent_demo_controller"
application.register("agent-demo", AgentDemoController)

import AiAssistantController from "./ai_assistant_controller"
application.register("ai-assistant", AiAssistantController)

import AnnouncementFormController from "./announcement_form_controller"
application.register("announcement-form", AnnouncementFormController)

import AutoResizeController from "./auto_resize_controller"
application.register("auto-resize", AutoResizeController)

import AutodetectController from "./autodetect_controller"
application.register("autodetect", AutodetectController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import CategoryComboboxController from "./category_combobox_controller"
application.register("category-combobox", CategoryComboboxController)

import ChartThemeController from "./chart_theme_controller"
application.register("chart-theme", ChartThemeController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CodeExpiryController from "./code_expiry_controller"
application.register("code-expiry", CodeExpiryController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)


import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import DnsCheckController from "./dns_check_controller"
application.register("dns-check", DnsCheckController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditorPreviewController from "./editor_preview_controller"
application.register("editor-preview", EditorPreviewController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FilterSearchController from "./filter_search_controller"
application.register("filter-search", FilterSearchController)

import HeatmapController from "./heatmap_controller"
application.register("heatmap", HeatmapController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LikeController from "./like_controller"
application.register("like", LikeController)

import LocaleSwitcherController from "./locale_switcher_controller"
application.register("locale-switcher", LocaleSwitcherController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import ModeToggleController from "./mode_toggle_controller"
application.register("mode-toggle", ModeToggleController)

import NotificationDropdownController from "./notification_dropdown_controller"
application.register("notification-dropdown", NotificationDropdownController)

import ScheduleController from "./schedule_controller"
application.register("schedule", ScheduleController)

import SeriesComboboxController from "./series_combobox_controller"
application.register("series-combobox", SeriesComboboxController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ShareMenuController from "./share_menu_controller"
application.register("share-menu", ShareMenuController)

import TagActionsController from "./tag_actions_controller"
application.register("tag-actions", TagActionsController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)

import TerminalController from "./terminal_controller"
application.register("terminal", TerminalController)

import ThemePreviewController from "./theme_preview_controller"
application.register("theme-preview", ThemePreviewController)

import TranslateController from "./translate_controller"
application.register("translate", TranslateController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UmamiTrackingController from "./umami_tracking_controller"
application.register("umami-tracking", UmamiTrackingController)

import UsernameCheckController from "./username_check_controller"
application.register("username-check", UsernameCheckController)

import VisibilitySelectController from "./visibility_select_controller"
application.register("visibility-select", VisibilitySelectController)
